export const DEFAULT_ERROR_MESSAGE_CODE = 'DEFAULT_ERROR_MESSAGE';

export const ERROR_CODE_MESSAGE = {
  'AccessDeniedException': '로그인이 필요합니다',
  'finaltest.record.ALREADY_EXISTS_GUID': '이미 FINAL TEST를 신청한 계정입니다.',
  'promotion.eventSchedule.NOT_START_SCHEDULE':'다음에 다시 시도해 주세요',
  'promotion.eventSchedule.ALREADY_END_SCHEDULE': 'FINAL TEST 신청 기간이 종료되었습니다.',
  'promotion.eventSchedule.NOT_EXIST_SCHEDULE': '다음에 다시 시도해 주세요.',

  // CBT
  'cbt.NOT_LOGIN_USER': '로그인이 필요합니다',
  // 'cbt.cbt.selfCert.RESTRICTED_AGE': '만 18세 미만은 신청이 불가능합니다',
  'cbt.ALREADY_END_SCHEDULE': '베타 테스트 신청 기간이 종료되었습니다.',
  'cbt.RESTRICTED_AGE': '만 18세 미만은 신청이 불가능합니다',
  'cbt.AVAILABLE_ONLY_KOREA': '한국 계정만 신청 가능합니다',



  [DEFAULT_ERROR_MESSAGE_CODE]: '다음에 다시 시도해 주세요',


};

export type ErrorCodeKey = keyof typeof ERROR_CODE_MESSAGE;

export default ERROR_CODE_MESSAGE;
